export default __webpack_public_path__ + "static/media/swing_auto.44836a02.svg";